/** @format */
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';

import { MarketContext } from '@toucan/client/global/market';

import { MarketSelectorModalLink } from './components/modal-link';
import {
    Heading,
    MarketSelectorModalWrapper,
    Selectable,
    Selected,
} from './modal.styles';

export const MarketSelectorModal = () => {
    const { t } = useTranslation();
    const { activeMarket, availableMarkets } = useContext(MarketContext);

    const selected = availableMarkets.find(
        (market) => market.code === activeMarket.code
    )!;

    const selectable = availableMarkets
        .filter((market) => market.code !== activeMarket.code)
        .sort((a, b) => a.name.localeCompare(b.name));

    return (
        <MarketSelectorModalWrapper data-testid="market-selector-modal">
            <Heading className="heading" size={HeadingSize.H3}>
                {t('Explore MPB in:')}
            </Heading>
            <Selected data-testid="market-selector-modal__selected-market">
                <p>{t('Selected')}:</p>
                <MarketSelectorModalLink market={selected} selected />
            </Selected>
            <Selectable data-testid="market-selector-modal__selectable-markets">
                {selectable.map((market) => (
                    <MarketSelectorModalLink
                        key={market.code}
                        market={market}
                    />
                ))}
            </Selectable>
        </MarketSelectorModalWrapper>
    );
};
